import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Badge, Table} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { NumericFormat } from 'react-number-format';
import { hasPerm, formataDataHoraExibicao, formatarValor, getCurrentUser, situacoesAgendamento, formatarValorLocal } from '../../common/utils';
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport } from "react-icons/fa";

class CreditoAntecipacaoEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.state = {
            prestador_id: '',
            prestador_nome: '',
            cliente_id: '',
            cliente_nome: '',
            programa_id: '',
            programa_nome: '',
            valor_unitario: "",      // Valor unitário do serviço (string “1234.56”)
            valor_total: "",         // Valor total calculado (string “1234.56”)
            nfe: '',
            status: '',
            servico_procedimento_id: '',
            servico_procedimento_nome: '',
            servico_procedimento_valor: '',
            quantidade: '',
            quantidade_utilizada: '',
            data_criacao: '',
            faturamento_id: '',
            dados_prestador: Object,
            dados_servico_procedimento: Object,
            erroLoadRegistro: "",
            titulo_pagina: "",
            loading: false,
            PrestadorIdHelper: '', 
            ValorHelper: '',
            NfeHelper: '',
            ServicoProcedimentoIdHelper: '',
            SituacaoHelper: '',
            key_programa: 0,
            key_prestador: 0,
            key_servico: 0,
            programServices: [],
            servicos_credito: []
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        this.setState({
            credito_id: id,
            loading: true,
            erroLoadRegistro: ''
        })

        if(id){
            //consulta os dados do agendamento na api
            api.get(`/credito-antecipacao/${id}`)
            .then(response => {
                const dados = response.data;

                const quantidadeNum = parseInt(dados.quantidade, 10) || 0;
                const totalNum = parseFloat(dados.valor) || 0;
                const unitComputed = quantidadeNum > 0 ? (totalNum / quantidadeNum).toFixed(2) : "0.00";

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    prestador_id: dados.prestador_id,
                    prestador_nome: dados.dados_prestador.nome,
                    programa_id: dados.programa_id,
                    programa_nome: dados.dados_programa.nome,
                    servico_procedimento_id: dados.servico_procedimento_id,
                    servico_procedimento_nome: dados.dados_servico_procedimento.nome,
                    dados_prestador: dados.dados_prestador,
                    dados_servico_procedimento: dados.dados_servico_procedimento,
                    quantidade_utilizada: dados.quantidade_utilizada,
                    valor_unitario: unitComputed,
                    quantidade: quantidadeNum,
                    valor_total: totalNum.toFixed(2),
                    status: dados.status,
                    data_criacao: dados.data_criacao,
                    faturamento_id: dados.faturamento_id,
                    loading: false,
                    titulo_pagina: 'Visualizar Crédito Antecipação: ',
                }, () => {
                    this.getServicosCredito();
                })                
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar crédito, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                credito_id: '',
                titulo_pagina: 'Adicionar Crédito Antecipação',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    getServicosCredito = () => {
        api.get(`/atendimentos/servicos/?credito_antecipacao_id=${this.state.credito_id}&limit=500`)
        .then(response => {
            this.setState({ 
                servicos_credito: response.data.results,
            });
        })

        .catch(error => {
            console.error('Erro ao carregar serviços do atendimento:', error);
            Sentry.captureException('Erro ao carregar serviços do atendimento:', error);                                
        });
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            PrestadorIdHelper: '',
            ServicoProcedimentoIdHelper: '',
        });

        //verifica se é edição ou adição
        const url = (this.state.credito_id) ? '/credito-antecipacao/'+this.state.credito_id+'/' : '/credito-antecipacao/';
        const metodo = (this.state.credito_id) ? 'put' : 'post';

        formData.append('cliente_id', this.state.cliente_id);
        formData.append('programa_id', this.state.programa_id);
        formData.append('quantidade', this.state.quantidade);
        formData.append('prestador_id', this.state.prestador_id);
        formData.append('servico_procedimento_id', this.state.servico_procedimento_id);
        formData.append("valor", this.state.valor_total);
        formData.append("quantidade_utilizada", 0);
        formData.append("status", "pendente");

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.credito_id) ? 'Crédito atualizado com sucesso' : 'Crédito cadastrado com sucesso';

            MySwal.fire({
                title: 'Crédito Criado',
                icon: 'success',
                html: 'Crédito criado com sucesso',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.props.router.navigate("/creditosantecipacao");
                
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o crédito, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'programa_id'){
                        this.setState({ ProgramaIdHelper: value })
                    }
                    if(key === 'prestador_id'){
                        this.setState({ PrestadorIdHelper: value })
                    }
                    if(key === 'servico_procedimento_id'){
                        this.setState({ ServicoProcedimentoIdHelper: value })
                    }
                    if(key === 'quantidade'){
                        this.setState({ QuantidadeHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    // Busca todos os serviços do programa escolhido e armazena apenas os IDs em state.programServices
    fetchProgramServices(programaId) {
        api
        .get(`/programas/servicos_procedimentos/?programa=${programaId}&status=1&limit=200`)
        .then((response) => {
            const ids = response.data.results.map((srv) => srv.servico_procedimento_id);
            this.setState({ programServices: ids });
        })
        .catch((error) => {
            console.error("Erro ao buscar serviços do programa:", error);
            this.setState({ programServices: [] });
        });
    }

    handleChange(eventOrValue, fieldName) {
        // Se vier um objeto { value, label, ... }, é de um AsyncSelect
        if (fieldName === 'cliente_id') {
            const { value, label } = eventOrValue;
            this.setState((prev) => ({
                cliente_id: value,
                cliente_nome: label,
                // zera todos os campos subsequentes
                programa_id: '',
                programa_nome: '',
                prestador_id: '',
                prestador_nome: '',
                servico_procedimento_id: '',
                servico_procedimento_nome: '',
                servico_procedimento_valor: '',
                valor_unitario: "",
                valor_total: "",
                quantidade: "",
                // incrementa key para recriar AsyncSelects
                key_programa: prev.key_programa + 1,
                key_prestador: prev.key_prestador + 1,
                key_servico: prev.key_servico + 1,
            }));
        }
        else if (fieldName === 'programa_id') {
            const { value, label } = eventOrValue;
            this.setState((prev) => ({
                programa_id: value,
                programa_nome: label,
                // zera prestador e serviço
                prestador_id: '',
                prestador_nome: '',
                servico_procedimento_id: '',
                servico_procedimento_nome: '',
                servico_procedimento_valor: '',
                valor_unitario: "",
                valor_total: "",
                quantidade: "",
                key_prestador: prev.key_prestador + 1,
                key_servico: prev.key_servico + 1,
            }),
            () => {
                this.fetchProgramServices(value);
                }
            );
        } else if (fieldName === "servico_procedimento_id") {
            const { value, label, valor } = eventOrValue;
            this.setState((prev) => {
                //const quantidadeNum = parseInt(prev.quantidade, 10) || 0;
                //const unit = parseFloat(valor) || 0;
                //const total = (unit * quantidadeNum).toFixed(2);
                return {
                    servico_procedimento_id: value,
                    servico_procedimento_nome: label,
                    servico_procedimento_valor: valor,
                    // aqui preenchemos unitário e total:
                    //valor_unitario: String(valor),
                    //valor_total: total,
                    prestador_id: '',
                    prestador_nome: '',
                    key_prestador: prev.key_prestador + 1,
                };
            });
        }
        else if (fieldName === 'prestador_id') {
            const { value, label } = eventOrValue;
            this.setState((prev) => ({
                prestador_id: value,
                prestador_nome: label,
                // zera serviço/procedimento
            }));
        }
        else if (fieldName === "quantidade") {
            const novaQuantidade = eventOrValue.target.value;
            this.setState((prev) => {
                const unit = parseFloat(prev.valor_unitario) || 0;
                const total = (unit * (parseInt(novaQuantidade, 10) || 0)).toFixed(2);
                return {
                    quantidade: novaQuantidade,
                    valor_total: total,
                };
            });
        } else {
            // campos normais (quantidade/valor editável, etc)
            const { name, value } = eventOrValue.target;
            this.setState({ [name]: value });
        }
    }

    resetSelects() {
        this.setState((prev) => ({
            prestador_id: '',
            servico_procedimento_id: '',
            programa_id: '',
            cliente_id: '',
            servico_procedimento_valor: '',
            valor: '',
            key_programa: prev.key_programa + 1,
            key_prestador: prev.key_prestador + 1,
            key_servico: prev.key_servico + 1,
        }));
    }

    carregaPrestadores = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/prestadores/servicos_procedimentos/?nome=${inputValue}&servico_procedimento_id=${this.state.servico_procedimento_id}&status=1&programa_id=${this.state.programa_id}`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.prestador_id,
                label: `${prestador.dados_prestador.nome} (${prestador.dados_prestador.bairro}, ${prestador.dados_prestador.cidade}/${prestador.dados_prestador.uf})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    carregaServicoProcedimento = async (inputValue) => {
        try {
            const response = await api.get(
                `/programas/servicos_procedimentos/?programa=${this.state.programa_id}&servico_procedimento=${inputValue}&status=1&`
            );
            return response.data.results
                .filter((servico) =>
                    this.state.programServices.includes(servico.servico_procedimento_id)
                )
                .map((servico) => ({
                value: servico.servico_procedimento_id,
                label: servico.dados_servico.nome,
                valor: 0,//servico.valor,
            }));
        } catch (error) {
            console.error("Erro ao carregar serviço/procedimento:", error);
            return [];
        }
    };

    carregaClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: (cliente.dados_pessoa.razao_social) ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : cliente.dados_pessoa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.cliente_id) {
            return [];
        }
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    getBadgeVariant(status) {
        switch (status) {
            case 'pendente':
                return 'info';
            case 'aprovado':
                return 'success';
            case 'rejeitado':
                return 'warning';
            case 'cancelado':
                return 'danger';
            default:
                return 'secondary';
        }
    }

    // Coloca a primeira letra maiúscula
    capitalizeFirst(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    render(){
        const id = this.props.router.params.id;

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosCreditoAntecipacao" id="tabs-creditoAntecipacao" className="aditus-tabs">
                    <Tab eventKey="dadosCreditoAntecipacao" title="Dados do crédito">
                        <Card className="cardDestaque">
                            <Card.Body>           
                                <Form onSubmit={this.enviaRegistro}>
                                {id ? (
                                    <>
                                        <h4>Dados do Crédito de Antecipação</h4>
                                        <Row>  
                                            <Col sm={6} xs={12}>
                                                <label>CA: #</label>
                                                <span>
                                                    <strong>{this.state.credito_id} –{' '}</strong>
                                                    <Badge bg={this.getBadgeVariant(this.state.status)}>
                                                        {this.capitalizeFirst(this.state.status)}
                                                    </Badge>
                                                </span>
                                            </Col>  
                                            <Col sm={6} xs={12}>
                                                <label>Data de criação: </label>
                                                <span> {formataDataHoraExibicao(this.state.data_criacao)}</span>
                                            </Col>  
                                            <Col sm={6} xs={12}>
                                                <label>Programa: </label>
                                                <span> {this.state.programa_nome}</span>
                                            </Col>   
                                            <Col sm={6} xs={12}>
                                                <label>Serviço: </label>
                                                <span> {this.state.servico_procedimento_nome}</span>
                                            </Col> 
                                            <Col sm={6} xs={12}>
                                                <label>Prestador: </label>
                                                <span> {this.state.prestador_nome}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Valor total: </label>
                                                <span> {formatarValorLocal(this.state.valor_total)}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Faturamento: </label>
                                                <span> 
                                                    <Button variant="light" href={"/faturamentos/edit/"+this.state.faturamento_id} size="sm">
                                                        <FaRegEdit /> Visualizar Faturamento #{this.state.faturamento_id}
                                                    </Button>  
                                                </span>
                                            </Col>
                                        </Row> 
                                    </>    
                                ) : (
                                    <>
                                        <Row>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cliente</Form.Label>
                                                    <AsyncSelect
                                                        required
                                                        cacheOptions
                                                        loadOptions={this.carregaClientes}
                                                        defaultOptions
                                                        name="cliente_id"
                                                        placeholder={'Buscar cliente...'}
                                                        noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                        onChange={e => this.handleChange(e, 'cliente_id')}
                                                        value={this.state.cliente_id ? { value: this.state.cliente_id, label: this.state.cliente_nome } : null}
                                                    />
                                                    <Form.Text id="clienteHelper" className="text-danger">{this.state.clienteHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>

                                            {this.state.cliente_id && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Programa</Form.Label>
                                                    <AsyncSelect
                                                        key={`programa-${this.state.key_programa}`}  // Adicione a chave única aqui
                                                        required
                                                        cacheOptions
                                                        loadOptions={this.carregaProgramas}
                                                        defaultOptions
                                                        name="programa_id"
                                                        placeholder={'Buscar programa...'}
                                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                                        onChange={e => this.handleChange(e, 'programa_id')}
                                                        value={this.state.programa_id ? { value: this.state.programa_id, label: this.state.programa_nome } : null}
                                                    />
                                                    <Form.Text id="programaHelper" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            )}
                                            {this.state.programa_id && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Serviço/Procedimento</Form.Label>
                                                    <AsyncSelect
                                                        key={`servico-${this.state.key_servico}`}  // Adicione a chave única aqui
                                                        required
                                                        cacheOptions
                                                        loadOptions={this.carregaServicoProcedimento}
                                                        defaultOptions
                                                        name="servico_procedimento_id"
                                                        placeholder="Buscar serviço/procedimento..."
                                                        noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                        onChange={e => this.handleChange(e, 'servico_procedimento_id')}
                                                        value={this.state.servico_procedimento_id ? { value: this.state.servico_procedimento_id, label: this.state.servico_procedimento_nome } : null}
                                                    />
                                                    <Form.Text id="formServicoProcedimentoIdHelpBlock" className="text-danger">{this.state.ServicoProcedimentoIdHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            )}
                                            {this.state.servico_procedimento_id && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Prestador</Form.Label>
                                                    <AsyncSelect
                                                        key={`prestador-${this.state.key_prestador}`}  // Adicione a chave única aqui
                                                        required
                                                        cacheOptions
                                                        loadOptions={this.carregaPrestadores}
                                                        defaultOptions
                                                        name="prestador_id"
                                                        placeholder='Selecionar prestador'
                                                        noOptionsMessage={() => "Nenhum resultado encontrado"}
                                                        onChange={e => this.handleChange(e, 'prestador_id')}
                                                        value={this.state.prestador_id ? { value: this.state.prestador_id, label: this.state.prestador_nome } : null}
                                                    />
                                                    <Form.Text id="PrestadorIdHelper" className="text-danger">{this.state.PrestadorIdHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            )}
                                            {this.state.prestador_id && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Valor Unitário do Serviço</Form.Label>
                                                    <NumericFormat
                                                        className="form-control"
                                                        name="valor"
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        prefix="R$ "
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        allowNegative={false}
                                                        placeholder="R$ 0,00"
                                                        value={this.state.valor}
                                                        onValueChange={(values) => {
                                                            this.setState((prev) => {
                                                                const unit = parseFloat(values.value) || 0;
                                                                const qty = parseInt(prev.quantidade, 10) || 0;
                                                                const total = (unit * qty).toFixed(2);
                                                                return {
                                                                    valor_unitario: values.value,
                                                                    valor_total: total,
                                                                };
                                                            });
                                                        }}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            )}
                                            {this.state.prestador_id && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Quantidade de créditos</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="quantidade"
                                                        value={this.state.quantidade} 
                                                        required
                                                        onChange={e => this.handleChange(e, 'quantidade')}
                                                    />
                                                    <Form.Text id="formQuantidadeHelpBlock" className="text-danger">{this.state.QuantidadeHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            )}
                                            {this.state.prestador_id && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Valor Total</Form.Label>
                                                    <NumericFormat
                                                        className="form-control"
                                                        name="valor_total"
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        prefix="R$ "
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        allowNegative={false}
                                                        value={this.state.valor_total}
                                                        disabled
                                                    />
                                                    <Form.Text id="valorHelper" className="text-danger">
                                                        {this.state.ValorHelper}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            )}
                                        </Row>

                                        {this.state.erroLoadRegistro ? 
                                        <Alert variant="warning">
                                            {this.state.erroLoadRegistro}
                                        </Alert> : ''
                                        }          
                                        {this.state.servico_procedimento_id && (                            
                                        <Button type="submit" className="btn btn-first mt-3" disabled={this.state.loading}>
                                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar'}                                       
                                        </Button>
                                        )}
                                    </>
                                )}
                                </Form> 
                            </Card.Body>                
                        </Card>
                        {id && (
                        <Card className="cardDestaque">
                            <Card.Body>  
                                <h4 className="mt-2">Serviços/Procedimentos Descontados</h4>
                                <p>Quantidade: {this.state.quantidade_utilizada}/{this.state.quantidade}</p>

                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Atendimento</th>         
                                            <th>Data</th>
                                            <th>Data Agendamento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        this.state.servicos_credito.map((item) =>
                                            <tr key={item.id}>
                                                <td>
                                                    #{item.id}
                                                </td>
                                                <td>
                                                    {item.atendimento_id ? item.atendimento_id : '---'}
                                                </td>                                            
                                                <td>{formataDataHoraExibicao(item.data)}</td>
                                                <td>{formataDataHoraExibicao(item.dados_agendamento.data_agendamento)}</td>      
                                            </tr>
                                        )
                                        } 
                                        {
                                        this.state.servicos_credito.length === 0 &&
                                            <tr>
                                                <td colSpan={3} align="center">Nenhum serviço descontado</td>
                                            </tr>
                                        }                                              
                                    </tbody>                                                                                
                                </Table> 
                            </Card.Body>                
                        </Card>
                        )}
                    </Tab>                    
                </Tabs>
            </div>
        )
    }
}

export default withRouter(CreditoAntecipacaoEdit);